import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DatacontextService } from 'src/app/data/datacontext.service';

@Component({
  selector: 'app-select-module-dialog',
  templateUrl: './select-module-dialog.component.html',
  styleUrls: ['./select-module-dialog.component.scss']
})
export class SelectModuleDialogComponent implements OnInit {
  moduleLoading: boolean;
  selectedModule: any;
  moduleList = [];
  btnPromise: any;
  moduleSearchText = '';
  constructor(
    private dialogRef: MatDialogRef<SelectModuleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datacontextService: DatacontextService
  ) { }

  ngOnInit() {
    this.getModuleList(this.data.app_id);
  }

  buildModuleListParams(appId) {
    const dataToSend = {
      'app_id': appId,
      'q': '',
      'l': 0,
      'o': 0,
    };
    return dataToSend;
  }

  getModuleList(appId) {
    this.moduleLoading = true;
    const dataToSend = this.buildModuleListParams(appId);
    return this.datacontextService.datasource.getModuleList(dataToSend).subscribe((data: any) => {
      this.moduleLoading = false;
      if (data.is_error) {
        return;
      }
      this.moduleListLoadComplete(data.api_response.module_list);
    }, (err) => {
      this.moduleLoading = false;
    });
  }

  moduleListLoadComplete(moduleList) {
    this.moduleList = moduleList;
  }

  tagRemoveCallback() {
    this.selectedModule = {};
  }

  attachDeepConfigToModule() {
    this.btnPromise = this.datacontextService.datasource.attachDeepConfigsToModule(
      this.data.app_id,
      [this.data.deepconfig_id],
      this.selectedModule.module_id
    ).subscribe((data: any) => {
      if (data.is_error) {
        return;
      }
      this.dialogRef.close(this.selectedModule.name);
    }, (err) => {
    });
  }

  queryTextChange(text: string) {
    if (this.moduleSearchText !== text) {
      this.moduleSearchText = text;
    }
  }

}
